module.exports = __webpack_public_path__ + "images/expand4919d3e2a1e0566fdfbde133f89746ab.png";